import { createContext, useContext } from 'react';

/** True while a shopper is past the welcome screen. Provided by EposFlow. */
export const SessionActiveContext = createContext<boolean>(true);

/**
 * False once the flow is back on welcome (idle timeout, start over, order
 * done). Components that keep their own modals open use it to close them,
 * since a portalled modal outlives the menu sheet sliding away.
 */
const useSessionActive = (): boolean => useContext(SessionActiveContext);

export default useSessionActive;
